import { SortingState } from "@tanstack/react-table";

/**
 * Resolve a table's sorting state to the field name the API sorts on.
 *
 * Most columns are named after the field behind them, but some render a derived
 * or renamed value — a date range, a quarter, an ARR/MRR column that follows the
 * account's setting. Sending those column ids as the sort field leaves the server
 * with nothing to sort by, so the table comes back in its natural order.
 */
export const resolveSortField = (
  sorting: SortingState,
  sortFieldByColumn: Record<string, string> = {}
): string | undefined => {
  const columnId = sorting[0]?.id;
  if (!columnId) return undefined;
  // The deals page seeds its column id from a URL parameter, so the id can be
  // any string a link carries — including one that names something inherited
  // from Object.prototype. Only an entry the map owns counts as a mapping.
  return Object.prototype.hasOwnProperty.call(sortFieldByColumn, columnId)
    ? sortFieldByColumn[columnId]
    : columnId;
};
